import SvgIcon from '@material-ui/core/SvgIcon';
import $ from 'jquery';

const config = {
  getRootURL() {
    if (process.env.REACT_APP_PRODUCTION == 'production') {
      return process.env.REACT_APP_DOMAIN_API;
    } else {
      return process.env.REACT_APP_DOMAIN_API;
    }
  },

  showLoader() {
    //const loader = document.querySelector('.loader');
    //loader.classList.remove('loader--hide');
    $('.loader').show();
  },
  hideLoader() {
    //const loader = document.querySelector('.loader');
    //loader.classList.add('loader--hide');
    $('.loader').hide();
  },
  getUrlQueryParams() {
    var queryParams = {},
      param;
    var params = window.location.search.substring(1).split('&');
    for (var i = 0; i < params.length; i++) {
      param = params[i].split('=');
      queryParams[param[0]] = param[1];
    }
    return params;
  },
  HomeIcon(props) {
    return (
      <SvgIcon {...props}>
        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
      </SvgIcon>
    );
  },
  HomeIconGanGV(props) {
    return (
      <SvgIcon {...props}>
        <path d="M13.388,9.624h-3.011v-3.01c0-0.208-0.168-0.377-0.376-0.377S9.624,6.405,9.624,6.613v3.01H6.613c-0.208,0-0.376,0.168-0.376,0.376s0.168,0.376,0.376,0.376h3.011v3.01c0,0.208,0.168,0.378,0.376,0.378s0.376-0.17,0.376-0.378v-3.01h3.011c0.207,0,0.377-0.168,0.377-0.376S13.595,9.624,13.388,9.624z M10,1.344c-4.781,0-8.656,3.875-8.656,8.656c0,4.781,3.875,8.656,8.656,8.656c4.781,0,8.656-3.875,8.656-8.656C18.656,5.219,14.781,1.344,10,1.344z M10,17.903c-4.365,0-7.904-3.538-7.904-7.903S5.635,2.096,10,2.096S17.903,5.635,17.903,10S14.365,17.903,10,17.903z" />
      </SvgIcon>
    );
  },
  HomeIconXoaGV(props) {
    return (
      <SvgIcon {...props}>
        <path d="M10,1.344c-4.781,0-8.656,3.875-8.656,8.656c0,4.781,3.875,8.656,8.656,8.656c4.781,0,8.656-3.875,8.656-8.656C18.656,5.219,14.781,1.344,10,1.344z M10,17.903c-4.365,0-7.904-3.538-7.904-7.903S5.635,2.096,10,2.096S17.903,5.635,17.903,10S14.365,17.903,10,17.903z M13.388,9.624H6.613c-0.208,0-0.376,0.168-0.376,0.376s0.168,0.376,0.376,0.376h6.775c0.207,0,0.377-0.168,0.377-0.376S13.595,9.624,13.388,9.624z" />
      </SvgIcon>
    );
  },
  HomeIconXoa(props) {
    return (
      <SvgIcon {...props}>
        <path
          d="M7.083,8.25H5.917v7h1.167V8.25z M18.75,3h-5.834V1.25c0-0.323-0.262-0.583-0.582-0.583H7.667
								c-0.322,0-0.583,0.261-0.583,0.583V3H1.25C0.928,3,0.667,3.261,0.667,3.583c0,0.323,0.261,0.583,0.583,0.583h1.167v14
								c0,0.644,0.522,1.166,1.167,1.166h12.833c0.645,0,1.168-0.522,1.168-1.166v-14h1.166c0.322,0,0.584-0.261,0.584-0.583
								C19.334,3.261,19.072,3,18.75,3z M8.25,1.833h3.5V3h-3.5V1.833z M16.416,17.584c0,0.322-0.262,0.583-0.582,0.583H4.167
								c-0.322,0-0.583-0.261-0.583-0.583V4.167h12.833V17.584z M14.084,8.25h-1.168v7h1.168V8.25z M10.583,7.083H9.417v8.167h1.167V7.083
								z"
        />
      </SvgIcon>
    );
  },
  HomeIconPhone(props) {
    return (
      <SvgIcon {...props}>
        <path d="M10,15.654c-0.417,0-0.754,0.338-0.754,0.754S9.583,17.162,10,17.162s0.754-0.338,0.754-0.754S10.417,15.654,10,15.654z M14.523,1.33H5.477c-0.833,0-1.508,0.675-1.508,1.508v14.324c0,0.833,0.675,1.508,1.508,1.508h9.047c0.833,0,1.508-0.675,1.508-1.508V2.838C16.031,2.005,15.356,1.33,14.523,1.33z M15.277,17.162c0,0.416-0.338,0.754-0.754,0.754H5.477c-0.417,0-0.754-0.338-0.754-0.754V2.838c0-0.417,0.337-0.754,0.754-0.754h9.047c0.416,0,0.754,0.337,0.754,0.754V17.162zM13.77,2.838H6.23c-0.417,0-0.754,0.337-0.754,0.754v10.555c0,0.416,0.337,0.754,0.754,0.754h7.539c0.416,0,0.754-0.338,0.754-0.754V3.592C14.523,3.175,14.186,2.838,13.77,2.838z M13.77,13.77c0,0.208-0.169,0.377-0.377,0.377H6.607c-0.208,0-0.377-0.169-0.377-0.377V3.969c0-0.208,0.169-0.377,0.377-0.377h6.785c0.208,0,0.377,0.169,0.377,0.377V13.77z" />
      </SvgIcon>
    );
  },
  IconView(props) {
    return (
      <SvgIcon {...props}>
        <path d="M10,6.978c-1.666,0-3.022,1.356-3.022,3.022S8.334,13.022,10,13.022s3.022-1.356,3.022-3.022S11.666,6.978,10,6.978M10,12.267c-1.25,0-2.267-1.017-2.267-2.267c0-1.25,1.016-2.267,2.267-2.267c1.251,0,2.267,1.016,2.267,2.267C12.267,11.25,11.251,12.267,10,12.267 M18.391,9.733l-1.624-1.639C14.966,6.279,12.563,5.278,10,5.278S5.034,6.279,3.234,8.094L1.609,9.733c-0.146,0.147-0.146,0.386,0,0.533l1.625,1.639c1.8,1.815,4.203,2.816,6.766,2.816s4.966-1.001,6.767-2.816l1.624-1.639C18.536,10.119,18.536,9.881,18.391,9.733 M16.229,11.373c-1.656,1.672-3.868,2.594-6.229,2.594s-4.573-0.922-6.23-2.594L2.41,10l1.36-1.374C5.427,6.955,7.639,6.033,10,6.033s4.573,0.922,6.229,2.593L17.59,10L16.229,11.373z" />
      </SvgIcon>
    );
  },

  IsValidEmail(address) {
    return !!address.match(/.+@.+/);
  },
  ChangeNumber(evt) {
    return evt.target.validity.valid ? evt.target.value : '';
  },

  //<a href={validateURL(url) ? url : ''}>Click here!</a>
  validateURL(url) {
    const parsed = new URL(url);
    return ['https:', 'http:'].includes(parsed.protocol);
  },

  AddDataIntoCache(cacheName, url, responseData) {
    const data = new Response(JSON.stringify(responseData));
    if ('caches' in window) {
      // Opening given cache and putting our data into it
      caches.open(cacheName).then((cache) => {
        return cache.put(url, data);
      });
    }
  },

  DeleteDataIntoCache(cacheName, url) {
    if ('caches' in window) {
      caches.open(cacheName).then((cache) => {
        return cache.delete(url);
      });
    }
  },

  readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  enableInfo() {
    return true;
  },

  titleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  },
  getTime(s) {
    if (s > 9) {
      return s;
    }
    return `0${s}`;
  },
  // xử lý khi thư viện chưa hỗ trợ mở dấu giá trị tuyệt đối như |, [
  // Note: Gọi convertMathJaxTablesToHtml() sau khi MathJax render xong để convert tables
  convertAllMfencedInHtml(htmlString) {
    return htmlString;
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const mfencedTags = doc.querySelectorAll('mfenced');
    mfencedTags.forEach((mfenced) => {
      if (
        mfenced.getAttribute('open') == null &&
        mfenced.getAttribute('close') == null
      ) {
        return;
      }
      // const open = mfenced.getAttribute("open") || "|";
      // const close = mfenced.getAttribute("close") || "|";
      const open = mfenced.getAttribute('open') || '';
      const close = mfenced.getAttribute('close') || '';
      const children = Array.from(mfenced.children);

      const mrow = doc.createElement('mrow');

      const moOpen = doc.createElement('mo');
      moOpen.textContent = open;
      mrow.appendChild(moOpen);

      children.forEach((child) => {
        mrow.appendChild(child.cloneNode(true));
      });

      const moClose = doc.createElement('mo');
      moClose.textContent = close;
      mrow.appendChild(moClose);

      mfenced.replaceWith(mrow);
    });

    return doc.body.innerHTML;
  },

  // Convert MathJax tables to HTML tables - Gọi sau khi MathJax render xong
  convertMathJaxTablesToHtml(container) {
    if (!container) container = document;

    const tables = container.querySelectorAll('mjx-mtable');

    tables.forEach((table) => {
      try {
        // Check if this is a system of equations/matrix (not a data table)
        const parent = table.parentElement;
        const grandParent = parent?.parentElement;

        // Skip if table is inside delimiters like {, [, |, (
        const hasDelimiter = parent?.querySelector(
          'mjx-mo[class*="mjx-c"], mjx-mo.mjx-delim'
        );
        if (hasDelimiter) {
          const delimText = hasDelimiter.textContent.trim();
          if (['{', '[', '|', '(', '⎧', '⎨', '⎩', '⎪'].includes(delimText)) {
            return; // Skip mathematical structures
          }
        }

        // Check parent structure - system of equations usually wrapped in mrow with mo
        if (
          grandParent
            ?.querySelector('mjx-mo')
            ?.textContent?.match(/[{}\[\]|()⎧⎨⎩⎪]/)
        ) {
          return; // Skip mathematical structures
        }

        // Extract table data
        const rows = Array.from(table.querySelectorAll('mjx-mtr'));
        if (rows.length === 0) return;

        // Additional check: Skip if only 1 column (likely system of equations)
        const firstRowCells = rows[0]?.querySelectorAll('mjx-mtd');
        if (firstRowCells && firstRowCells.length === 1) {
          return; // Skip single column tables (system of equations)
        }

        // Build HTML table
        const htmlTable = document.createElement('table');
        htmlTable.style.cssText =
          'border-collapse: collapse; width: 100%; max-width: 100%; margin: 10px 0;';

        rows.forEach((row, rowIndex) => {
          const tr = document.createElement('tr');
          const cells = Array.from(row.querySelectorAll('mjx-mtd'));

          cells.forEach((cell) => {
            const tag = rowIndex === 0 ? 'th' : 'td';
            const htmlCell = document.createElement(tag);

            // Extract content (text + images) from MathJax elements
            const extractContent = (element) => {
              const fragment = document.createDocumentFragment();

              element.childNodes.forEach((node) => {
                if (node.nodeType === Node.TEXT_NODE) {
                  const text = node.textContent;
                  // Check if text contains \includegraphics
                  const imgRegex = /\\includegraphics\{([^}]+)\}/g;
                  if (imgRegex.test(text)) {
                    // Replace \includegraphics with img tags
                    const parts = text.split(/\\includegraphics\{([^}]+)\}/g);
                    parts.forEach((part, idx) => {
                      if (idx % 2 === 0) {
                        // Regular text
                        if (part)
                          fragment.appendChild(document.createTextNode(part));
                      } else {
                        // URL - create img
                        const img = document.createElement('img');
                        img.src = part;
                        img.alt = '';
                        img.style.cssText =
                          'max-width: 80px; max-height: 20px; vertical-align: middle; margin: 0 2px; object-fit: contain; display: inline-block;';
                        fragment.appendChild(img);
                      }
                    });
                  } else {
                    fragment.appendChild(document.createTextNode(text));
                  }
                } else if (node.nodeName === 'MJX-MTEXT') {
                  // Get text from mjx-c and mjx-utext elements
                  let textContent = '';
                  node.childNodes.forEach((child) => {
                    if (child.nodeType === Node.TEXT_NODE) {
                      textContent += child.textContent;
                    } else if (child.nodeName === 'MJX-C') {
                      // Regular ASCII characters
                      const charClass = child.className || '';
                      const match = charClass.match(/mjx-c([0-9A-F]+)/);
                      if (match) {
                        const charCode = parseInt(match[1], 16);
                        textContent += String.fromCharCode(charCode);
                      }
                    } else if (child.nodeName === 'MJX-UTEXT') {
                      // Unicode characters (Vietnamese diacritics)
                      textContent += child.textContent;
                    }
                  });

                  // Check for \includegraphics in extracted text
                  const imgRegex = /\\includegraphics\{([^}]+)\}/g;
                  if (imgRegex.test(textContent)) {
                    const parts = textContent.split(
                      /\\includegraphics\{([^}]+)\}/g
                    );
                    parts.forEach((part, idx) => {
                      if (idx % 2 === 0) {
                        if (part)
                          fragment.appendChild(document.createTextNode(part));
                      } else {
                        const img = document.createElement('img');
                        img.src = part;
                        img.alt = '';
                        img.style.cssText =
                          'max-width: 80px; max-height: 20px; vertical-align: middle; margin: 0 2px; object-fit: contain; display: inline-block;';
                        fragment.appendChild(img);
                      }
                    });
                  } else {
                    fragment.appendChild(document.createTextNode(textContent));
                  }
                } else if (node.nodeName === 'MJX-C') {
                  const charClass = node.className || '';
                  const match = charClass.match(/mjx-c([0-9A-F]+)/);
                  if (match) {
                    const charCode = parseInt(match[1], 16);
                    fragment.appendChild(
                      document.createTextNode(String.fromCharCode(charCode))
                    );
                  }
                } else if (node.nodeName === 'MJX-UTEXT') {
                  fragment.appendChild(
                    document.createTextNode(node.textContent)
                  );
                } else if (node.childNodes.length > 0) {
                  const childFragment = extractContent(node);
                  fragment.appendChild(childFragment);
                }
              });

              return fragment;
            };

            // Extract and append content (text + images)
            const content = extractContent(cell);
            htmlCell.appendChild(content);

            // Style
            htmlCell.style.cssText = `
              border: 1px solid #ccc;
              padding: 8px 12px;
              text-align: left;
              word-wrap: break-word;
              word-break: normal;
              white-space: normal;
              vertical-align: top;
              max-width: 400px;
              min-height: 40px;
              line-height: 1.5;
              height: auto;
              overflow: visible;
              font-size: 13px;
              ${rowIndex === 0 ? 'background-color: #f5f5f5; font-weight: bold;' : ''}
            `;

            tr.appendChild(htmlCell);
          });

          htmlTable.appendChild(tr);
        });

        // Replace MathJax table with HTML table
        const mathElement = table.closest('mjx-math');
        if (mathElement && mathElement.parentNode) {
          mathElement.parentNode.replaceChild(htmlTable, mathElement);
        }
      } catch (e) {
        console.error('Error converting MathJax table:', e);
      }
    });

    return tables.length; // Return số lượng tables đã convert
  },

  // Convert tables with MathJax Promise - Đảm bảo MathJax đã render xong
  async convertMathJaxTablesWithPromise(container, options = {}) {
    const { maxRetries = 5, retryDelay = 300 } = options;

    if (!container) container = document;

    // Đợi MathJax typeset xong
    if (window.MathJax && window.MathJax.typesetPromise) {
      try {
        await window.MathJax.typesetPromise([container]);
      } catch (e) {
        console.warn('MathJax typeset error:', e);
      }
    }

    // Retry logic với exponential backoff
    let retries = 0;
    let converted = 0;

    const tryConvert = () => {
      const count = this.convertMathJaxTablesToHtml(container);
      converted += count;

      if (count > 0) {
        console.log(
          `[MathJax] Converted ${count} tables (total: ${converted})`
        );
      }

      return count;
    };

    // First attempt
    tryConvert();

    // Retry với exponential backoff nếu cần
    while (retries < maxRetries) {
      const currentRetry = retries;
      await new Promise((resolve) =>
        setTimeout(resolve, retryDelay * Math.pow(1.5, currentRetry))
      );
      const count = tryConvert();

      // Nếu không còn tables để convert, dừng
      if (count === 0 && retries >= 2) {
        break;
      }

      retries++;
    }

    return converted;
  },

  // Setup auto-convert MathJax tables sau khi render
  // Gọi function này trong useEffect của component có MathJax
  // DEPRECATED: Sử dụng convertMathJaxTablesWithPromise thay vì function này
  setupMathJaxTableConverter(dependencies = []) {
    // Sử dụng async version mới với retry logic
    this.convertMathJaxTablesWithPromise(document, {
      maxRetries: 5,
      retryDelay: 400
    });

    // Return empty cleanup function
    return () => {};
  },

  // Setup MutationObserver để auto-convert tables khi có MathJax mới
  // Hữu ích khi disable cache hoặc content load động
  setupMathJaxTableObserver(container) {
    if (!container) container = document.body;

    let convertTimeout = null;
    const debouncedConvert = () => {
      if (convertTimeout) clearTimeout(convertTimeout);
      convertTimeout = setTimeout(() => {
        this.convertMathJaxTablesToHtml(container);
      }, 200);
    };

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        // Check nếu có mjx-mtable được thêm vào
        if (mutation.addedNodes.length > 0) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1) {
              // ELEMENT_NODE
              if (
                node.tagName === 'MJX-MTABLE' ||
                node.querySelector?.('mjx-mtable')
              ) {
                debouncedConvert();
                break;
              }
            }
          }
        }
      }
    });

    observer.observe(container, {
      childList: true,
      subtree: true
    });

    // Return cleanup function
    return () => {
      observer.disconnect();
      if (convertTimeout) clearTimeout(convertTimeout);
    };
  }
};

// Hàm chia phần môn chung
export function divideSubject(arrSubject, slicePoints) {
  let part1 = arrSubject.slice(0, slicePoints[0]);
  if (slicePoints[1] != 0) {
    let part2 = arrSubject.slice(slicePoints[0], slicePoints[1]);
    if (slicePoints[2] != 0) {
      let part3 = arrSubject.slice(slicePoints[1], slicePoints[2]);
      return { part1, part2, part3 };
    }
    return { part1, part2 };
  }
  return { part1 };
}

// Hàm cho loại 1: 1 Toán
export function divideSubjectType1(
  arrSubject,
  totalP1 = 0,
  totalP2 = 0,
  totalP3 = 0
) {
  //return divideSubject(arrSubject, [12, 16, 22]);
  return divideSubject(arrSubject, [totalP1, totalP2, totalP3]);
}

// Hàm cho loại 2: 6 Lý, 7 Hóa, 9 Sinh, 11 Địa
export function divideSubjectType2(
  arrSubject,
  totalP1 = 0,
  totalP2 = 0,
  totalP3 = 0
) {
  //return divideSubject(arrSubject, [18, 22, 28]);
  return divideSubject(arrSubject, [totalP1, totalP2, totalP3]);
}

// Hàm cho loại 3: 10 Sử, 12 GDCD, 15 [CN công nghiệp, CN nông nghiệp], 31 Giáo dục kinh tế & Pháp luật
export function divideSubjectType3(
  arrSubject,
  totalP1 = 0,
  totalP2 = 0,
  totalP3 = 0
) {
  //return divideSubject(arrSubject, [24, 28, 0]);
  return divideSubject(arrSubject, [totalP1, totalP2, totalP3]);
}

// Hàm cho loại 4: 8 Anh
export function divideSubjectType4(
  arrSubject,
  totalP1 = 0,
  totalP2 = 0,
  totalP3 = 0
) {
  //return divideSubject(arrSubject, [40, 0, 0]);
  return divideSubject(arrSubject, [totalP1, totalP2, totalP3]);
}

// Hàm cho loại 5: 14 Tin
export function divideSubjectType5(
  arrSubject,
  totalP1 = 0,
  totalP2 = 0,
  totalP3 = 0
) {
  //return divideSubject(arrSubject, [24, 30, 0]);
  return divideSubject(arrSubject, [totalP1, totalP2, totalP3]);
}

// Hàm chia phần nhỏ môn Tin
export function divideSubjectSubPart(arrSubject, slicePoints) {
  let subPart1 = arrSubject.slice(0, slicePoints[0]);
  if (slicePoints[1] != 0) {
    let subPart2 = arrSubject.slice(slicePoints[0], slicePoints[1]);
    if (slicePoints[2] != 0) {
      let subPart3 = arrSubject.slice(slicePoints[1], slicePoints[2]);
      return { subPart1, subPart2, subPart3 };
    }
    return { subPart1, subPart2 };
  }
  return { subPart1 };
}

// Phần 2 môn Tin: 6 câu,chia 3 phần, mỗi phần 2 câu
export function divideSubjectType5SubPart(
  arrSubject,
  totalP1 = 0,
  totalP2 = 0,
  totalP3 = 0
) {
  return divideSubjectSubPart(arrSubject, [2, 4, 6]);
  //return divideSubjectSubPart(arrSubject, [totalP1, totalP2, totalP3]);
}

export function showMessagePartTHPT(subject_id, part, caucuoi = 0) {
  var strPart = '';
  if (subject_id == 1) {
    // môn Toán
    if (part == 1) {
      strPart =
        ' Câu trắc nghiệm nhiều phương án lựa chọn. Thí sinh trả lời câu 1 đến câu ' +
        caucuoi +
        '. Mỗi câu hỏi thí sinh chỉ chọn một phương án.';
    } else if (part == 2) {
      strPart =
        ' Câu trắc nghiệm đúng sai. Thí sinh trả lời câu 1 đến câu ' +
        caucuoi +
        '. Trong mỗi ý a), b), c), d) ở mỗi câu, thí sinh chọn đúng hoặc sai.';
    } else if (part == 3) {
      strPart =
        ' Câu trắc nghiệm trả lời ngắn. Thí sinh trả lời từ câu 1 đến câu ' +
        caucuoi +
        '.';
    }
  } else if (
    subject_id == 6 ||
    subject_id == 7 ||
    subject_id == 9 ||
    subject_id == 11
  ) {
    //6 Lý, 7 Hóa, 9 Sinh, 11 Địa
    if (part === 1) {
      strPart =
        ' Câu trắc nghiệm nhiều phương án lựa chọn. Thí sinh trả lời câu 1 đến câu ' +
        caucuoi +
        '. Mỗi câu hỏi thí sinh chỉ chọn một phương án.';
    } else if (part === 2) {
      strPart =
        ' Câu trắc nghiệm đúng sai. Thí sinh trả lời câu 1 đến câu ' +
        caucuoi +
        '. Trong mỗi ý a), b), c), d) ở mỗi câu, thí sinh chọn đúng hoặc sai.';
    } else if (part === 3) {
      strPart =
        ' Câu trắc nghiệm trả lời ngắn. Thí sinh trả lời từ câu 1 đến câu ' +
        caucuoi +
        '.';
    }
  } else if (
    subject_id == 10 ||
    subject_id == 12 ||
    subject_id == 15 ||
    subject_id == 31
  ) {
    // 10 Sử, 12 GDCD, 15 [CN công nghiệp, CN nông nghiệp], 31 Giáo dục kinh tế & Pháp luật
    if (part === 1) {
      strPart =
        ' Câu trắc nghiệm nhiều phương án lựa chọn. Thí sinh trả lời câu 1 đến câu ' +
        caucuoi +
        '. Mỗi câu hỏi thí sinh chỉ chọn một phương án.';
    } else if (part === 2) {
      strPart =
        ' Câu trắc nghiệm đúng sai. Thí sinh trả lời câu 1 đến câu ' +
        caucuoi +
        '. Trong mỗi ý a), b), c), d) ở mỗi câu, thí sinh chọn đúng hoặc sai.';
    } else if (part == 3) {
      // bo sung de tu do
      strPart =
        ' Câu trắc nghiệm trả lời ngắn. Thí sinh trả lời từ câu 1 đến câu ' +
        caucuoi +
        '.';
    }
  } else if (subject_id == 14) {
    //14 Tin
    if (part === 1) {
      strPart =
        ' Câu trắc nghiệm nhiều phương án lựa chọn. Thí sinh trả lời câu 1 đến câu ' +
        caucuoi +
        '. Mỗi câu hỏi thí sinh chỉ chọn một phương án.';
    } else if (part === 2) {
      strPart =
        ' Câu trắc nghiệm đúng sai. Thí sinh trả lời câu 1 đến câu ' +
        caucuoi +
        '. Trong mỗi ý a), b), c), d) ở mỗi câu, thí sinh chọn đúng hoặc sai.';
    } else if (part == 3) {
      // bo sung de tu do
      strPart =
        ' Câu trắc nghiệm trả lời ngắn. Thí sinh trả lời từ câu 1 đến câu ' +
        caucuoi +
        '.';
    }
  } else if (subject_id == 8) {
    //8 Anh
    if (part === 1) {
      strPart =
        ' Câu trắc nghiệm nhiều phương án lựa chọn. Thí sinh trả lời câu 1 đến câu ' +
        caucuoi +
        '. Mỗi câu hỏi thí sinh chỉ chọn một phương án.';
    } else if (part === 2) {
      // bo sung de tu do
      strPart =
        ' Câu trắc nghiệm đúng sai. Thí sinh trả lời câu 1 đến câu ' +
        caucuoi +
        '. Trong mỗi ý a), b), c), d) ở mỗi câu, thí sinh chọn đúng hoặc sai.';
    } else if (part == 3) {
      // bo sung de tu do
      strPart =
        ' Câu trắc nghiệm trả lời ngắn. Thí sinh trả lời từ câu 1 đến câu ' +
        caucuoi +
        '.';
    }
  }
  return strPart;
}

export default config;
